// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__4fG+E","wrapper":"Loader_wrapper__ns0ps","moving":"Loader_moving__tVuzl"};